/** @format */
import striptags from 'striptags';

import { decimalToCent } from '@toucan/helpers/currency';

import {
    DeliveryOptionsResponse,
    ShippingOption,
    ShippingOptionType,
} from '@toucan/client/core/shipping';

export const transformShippingOptions = (
    shippingOptions: DeliveryOptionsResponse,
    type: ShippingOptionType
): ShippingOption[] => {
    const array: ShippingOption[] = shippingOptions.map((option: any) => ({
        ...option,
        type,
        hasDatePicker: option.allowDatepick,
        value: decimalToCent(option.value),
        price: option.value,
        title: option.displayName,
        description:
            type === ShippingOptionType.COLLECTION
                ? striptags(option.instruction)
                : '',
        subtitle:
            type === ShippingOptionType.SHIPPING ? option.description : '',
    }));

    // Sorts the options by their priority
    return array.sort((a, b) => {
        if (!a.priority || !b.priority) {
            return 0;
        }

        return a.priority - b.priority;
    });
};
